import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import fetch from './redux/actions';
import VodComponent from './vod-component';

function mapStateToProps(state: ApplicationState, ownProps: any) {
  return {
    general: state.devices.detail.general,
    hhid: ownProps.hhid,
    id: ownProps.id,
    t: state.i18n.t,
    vod: state.devices.detail.vod,
    offset: state.application.offset
  };
}

export default connect(mapStateToProps, {
  fetch
})(VodComponent);
